import { Editor, Element } from 'slate'

export function isBlockTypeActive (editor, type, key = 'type') {
  const { selection } = editor

  if (!selection) {
    return false
  }

  let result

  try {
    result = Array.from(
      Editor.nodes(editor, {
        at: Editor.unhangRange(editor, selection),
        match: n => (
          !Editor.isEditor(n) &&
          Element.isElement(n) &&
          n[key] === type
        )
      })
    )
  } catch (err) {
    return false
  }

  const [ match ] = result

  return !!match
}
